export default __webpack_public_path__ + "static/media/discussion2image1.d397ae09.JPG";